/* Article behaviour — progressive enhancement only (no-JS keeps everything
   visible for readers and crawlers):
   - adds .artc-anim to the article root, which arms the CSS load-in (title
     mask rise) and the scroll-reveal hidden states
   - reveals body blocks as they enter the viewport (IntersectionObserver)
   - wraps content images in a parallax frame (.artc_fig) that keeps the
     photo's own aspect ratio; journal-scroll.js (loaded after this file)
     picks them up via [data-journal-parallax]
   - drives the hairline reading-progress bar along the top
   Registry-managed: articles live inside the Barba container, so this re-runs
   after every swap; the observer and scroll listener die with the signal. */
(function () {
  function init(ctx) {
  var signal = ctx && ctx.signal;
  var root = document.querySelector('[data-artc]');
  if (!root) return;

  var body = root.querySelector('[data-artc-body]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- wrap content images for the parallax ---------- */
  if (body) {
    body.querySelectorAll('img').forEach(function (img) {
      if (img.closest('.artc_fig')) return;

      var fig = document.createElement('div');
      fig.className = 'artc_fig';

      // rich text usually emits <p><img></p> — replace the p, keep anything else
      var host = img.parentElement;
      if (host && host.tagName === 'P' && host.textContent.trim() === '' && host.children.length === 1) {
        host.parentNode.replaceChild(fig, host);
      } else {
        img.parentNode.insertBefore(fig, img);
      }
      fig.appendChild(img);
      img.setAttribute('data-journal-parallax', '');

      // frame takes the photo's own ratio once dimensions are known
      var setRatio = function () {
        if (img.naturalWidth && img.naturalHeight) {
          fig.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
        }
      };
      if (img.complete) setRatio();
      else img.addEventListener('load', setRatio);
    });
  }

  /* ---------- arm the animations ---------- */
  root.classList.add('artc-anim');

  /* ---------- scroll reveals ---------- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var targets = [];
    if (body) targets = targets.concat([].slice.call(body.children));
    targets = targets.concat([].slice.call(root.querySelectorAll('[data-artc-reveal]')));

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );

    if (signal) signal.addEventListener('abort', function () { io.disconnect(); });

    targets.forEach(function (el) {
      // anything already in view on load shows immediately (no pop-in)
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) el.classList.add('is-in');
      else io.observe(el);
    });
  } else {
    // reveal everything; CSS also neutralises the hidden state for reduced motion
    root.querySelectorAll('.artc_body > *, [data-artc-reveal]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  /* ---------- reading progress ---------- */
  var fill = root.querySelector('[data-artc-progress]');
  if (fill && !reduceMotion) {
    var ticking = false;

    var update = function () {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      fill.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
    };

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true, signal: signal }
    );
    update();
  }
  }

  if (window.Onni && window.Onni.register) {
    window.Onni.register('article', init);
  } else {
    init();
  }
})();
